import {Injectable} from '@angular/core';
import {PageRequest} from "@core/types";

const FILTROS_TABELAS = 'FILTROS_TABELAS';

type FilterStore = Record<string, PageRequest>;

@Injectable({ providedIn: 'root' })
export class FilterService {

  saveFilter(rota: string, pageRequest: PageRequest): void {
    const store = this._load();
    store[rota] = pageRequest;
    localStorage.setItem(FILTROS_TABELAS, JSON.stringify(store));
  }

  recoverFilter(rota: string): PageRequest | null {
    const store = this._load();
    return store[rota] ?? null;
  }

  removeFilter(rota: string): void {
    const store = this._load();
    delete store[rota];
    localStorage.setItem(FILTROS_TABELAS, JSON.stringify(store));
  }

  private _load(): FilterStore {
    try {
      const raw = localStorage.getItem(FILTROS_TABELAS);
      return JSON.parse(raw) ?? {};
    } catch {
      return {};
    }
  }
}
